import React from "react";
import { CloseIcon } from "../../assets"
import style from "./style.module.css"
import { useDispatch, useSelector } from "react-redux";
import { hideArtDetails } from "../../redux/slices/artDetailsSlice";
import { addItem } from "../../redux/slices/artItemSlice";
import { setCartVisibility } from "../../redux/slices/cartVisibilitySlice";
import { RootState } from "../../redux/store";

interface IArtDetailsDisplay
{
  handleCloseButton: () => void;
}

export const ArtDetailsDisplay: React.FC<IArtDetailsDisplay> = ({handleCloseButton}) =>
{

    // const { setIsCartVisible } = useCartVisibility();
    const dispatch = useDispatch();
    const isArtPopupVisible = useSelector((state: RootState) => state.ArtDetailsVisibility.isVisible);
    const artDetails = useSelector((state: RootState) => state.ArtDetailsVisibility.artData);

   // const testBase64: string = "data:image/jpeg;base64,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";

    const HandleClosePopup = () =>
    {
        // console.log('Clicked Close Popup')
        dispatch(hideArtDetails());
        handleCloseButton();
    }

    
    //artImage = testBase64 //Delete after testing
    const HandleAddToCart = () => {
      const details = artDetails;
      if (!details) return;

      dispatch(
        addItem({
          itemImage: details.artImage || "",
          itemPrice: details.artPrice || "",
          itemName: details.artName || "",
          artistName: details.artistName || "",
          itemSize: details.artSize || "",
        })
      );

      // setIsCartVisible(true);

      dispatch(hideArtDetails());
      dispatch(setCartVisibility(true));
    };

     const formatter = new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

    if (!isArtPopupVisible || !artDetails) return null;

    const {
    artName,
    artistName,
    artMedium,
    artPrice,
    artSize,
    artCreationDate,
    artAvailable,
    artImage,
  } = artDetails;

    return (
      <div className={style.overlay}>
        <div className={style.container}>
          <div className={style.imageContainer}>
            <img
              className={style.artImage}
              src={artImage}
              alt="Art Piece Preview"
            />

            <div className={style.closeBtnImage} onClick={HandleClosePopup}>
              <CloseIcon />
            </div>
          </div>

          <div className={style.detailsContainer}>
            <div className={style.detailsTextsCtn}>
              <div className={style.artName}>{artName} </div>
              <div className={style.artistName}>{`Artist: ${artistName}`}</div>
              <div className={style.artMedium}>{`Medium: ${artMedium}`} </div>
              {artPrice !== "0" && (
                <div className={style.artPrice}>{`Price: ${formatter.format(Number(artPrice))}`}</div>
              )}
              <div className={style.artSize}>{`Size: ${artSize}`} </div>
              <div className={style.artCreationDate}>{`Year Created: ${artCreationDate}`}</div>
              <div className={style.artAvailable}>{artAvailable}</div>
            </div>

            <div className={style.closeBtn} onClick={HandleClosePopup}>
              <CloseIcon />
            </div>

            {artAvailable !== "SOLD" && (
              <div className={style.detailsCtnBtns} onClick={HandleAddToCart}>
                Add To Cart
              </div>
            )}
          </div>
        </div>
      </div>
    );

}